export function getParentOrigin(): string {
  try {
    if (
      window.location.ancestorOrigins &&
      window.location.ancestorOrigins.length > 0
    ) {
      return window.location.ancestorOrigins[0];
    }
    if (document.referrer) {
      return new URL(document.referrer).origin;
    }
  } catch (error) {
    console.error("Error in getParentOrigin:", error);
    return "";
  }
  return "";
}

export function requestParentResize(
  isDesktopScreen: boolean,
  desktopHeight,
  mobileHeight
): void {
  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  window.parent.postMessage(
    {
      event_id: "iframeHeight",
      data: {
        iframeHeight: isDesktopScreen ? desktopHeight : mobileHeight,
      },
    },
    targetOrigin
  );
}

export const allowedOrigins = new Set([
  "https://mbrent.mercedes-benz.it",
  "https://bookingmerfina.mbrent.mercedes-benz.it",
  "https://mbrent.mercedes-benz.it/congaratulation",
  "https://merfinatestbooking.myrent.it",
  "https://mauroc147.myrent.it",
]);

export const blurScreen = () => {
  document.body.style.opacity = String(0.5);
  document.body.style.pointerEvents = "none";
};
